<script lang="ts">

    import { Icon } from "sveltestrap";

</script>

<button type="button" on:click>
    <Icon name="list" />
</button>

<style lang="scss">

    button {
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 50%;
        padding: 0;
        // border: 2px solid #fff;
        border: 2px solid black;
        // color: #fff;
        color: black;
        // background-color: transparent;
        background-color: var(--color-secondary)
    }

</style>
